import axios from 'axios'

const api = axios.create({ baseURL: '/api', withCredentials: true })

export const licenseServices = {
  async runtime() {
    const response = await api.get('/license/runtime', {
      headers: { 'Cache-Control': 'no-store' },
    })
    return response.data
  },
}

export const historyExportServices = {
  async search(filters) {
    const response = await api.post('/history-export/search', filters)
    return response.data.items || []
  },
  downloadUrl(id) {
    return `/api/history-export/artifacts/${encodeURIComponent(id)}/download`
  },
  async archive(artifactIds) {
    const response = await api.post('/history-export/archive/prepare', { artifact_ids: artifactIds })
    const downloadUrl = response.data && response.data.download_url
    if (typeof downloadUrl !== 'string' || !downloadUrl.startsWith('/api/history-export/archive/tickets/')) {
      throw new Error('INVALID_ARCHIVE_TICKET')
    }
    const link = document.createElement('a')
    link.href = downloadUrl
    link.download = ''
    document.body.appendChild(link)
    link.click()
    link.remove()
  },
}
